
<template>

	<div>

		<b-nav pills>

			<b-nav-item v-on:click="go_back" variant="primary">Назад</b-nav-item>

		</b-nav>

		<b-container fluid>

			<b-row class="mt-2" align-v="center">

				<b-col cols="3">Код подгруппы:</b-col>
				<b-col class="floor-height_show_field">

					<reference_values attr_key="attrs.functional_sub_group" v-model="raw_data.functional_sub_group" @input="(value) => save('functional_sub_group', value)" :readonly="$root.not_editable || ! check_roles([ 'model' ])"/>
					<b-form-invalid-feedback id="floor-height_functional_sub_group">Характеристика этажа для данного кода подгруппы уже присутствует в системе</b-form-invalid-feedback>

				</b-col>

			</b-row>

			<b-row class="mt-2" align-v="center">

				<b-col cols="3">Высота этажа, м:</b-col>
				<b-col class="floor-height_show_field">

					<b-form-input type="number" v-model="raw_data.floor_h" v-on:change="(value) => save('floor_h', value)"
						@input="(value) => validate('floor_h', value)" :formatter="(value) => formatter('floor_h', value)"
						:readonly="$root.not_editable || ! check_roles([ 'model' ])"
						:state="states.floor_h"
						aria-describedby="floor-height_floor_h"
					/>
					<b-form-invalid-feedback id="floor-height_floor_h" tooltip>Больше 0</b-form-invalid-feedback>

				</b-col>

			</b-row>

			<b-row class="mt-2" align-v="center">

				<b-col cols="3">Высота этажа подвала, м:</b-col>
				<b-col class="floor-height_show_field">

					<b-form-input type="number" v-model="raw_data.underground_h" v-on:change="(value) => save('underground_h', value)"
						@input="(value) => validate('underground_h', value)" :formatter="(value) => formatter('underground_h', value)"
						:readonly="$root.not_editable || ! check_roles([ 'model' ])"
						:state="states.underground_h"
						aria-describedby="floor-height_underground_h"
					/>
					<b-form-invalid-feedback id="floor-height_underground_h" tooltip>Больше 0</b-form-invalid-feedback>

				</b-col>

			</b-row>

			<b-row class="mt-2" align-v="center">

				<b-col cols="3">Коэффициент толщины стен:</b-col>
				<b-col class="floor-height_show_field">

					<b-form-input type="number" v-model="raw_data.wall_k" v-on:change="(value) => save('wall_k', value)"
						@input="(value) => validate('wall_k', value)" :formatter="(value) => formatter('wall_k', value)"
						:readonly="$root.not_editable || ! check_roles([ 'model' ])"
						:state="states.wall_k"
						aria-describedby="floor-height_wall_k"
					/>
					<b-form-invalid-feedback id="floor-height_wall_k" tooltip>Больше 0</b-form-invalid-feedback>

				</b-col>

			</b-row>

			<b-row class="mt-2" align-v="center">

				<b-col cols="3">Расчетный коэффициент (1/Коэффициент толщины стен):</b-col>
				<b-col>{{ raw_data.coef }}</b-col>

			</b-row>

			<b-row class="mt-2" align-v="center">

				<b-col cols="3">Толщина перекрытия, м:</b-col>
				<b-col class="floor-height_show_field">

					<b-form-input type="number" v-model="raw_data.overlap_h" v-on:change="(value) => save('overlap_h', value)"
						@input="(value) => validate('overlap_h', value)" :formatter="(value) => formatter('overlap_h', value)"
						:readonly="$root.not_editable || ! check_roles([ 'model' ])"
						:state="states.overlap_h"
						aria-describedby="floor-height_overlap_h"
					/>
					<b-form-invalid-feedback id="floor-height_overlap_h" tooltip>Больше 0</b-form-invalid-feedback>

				</b-col>

			</b-row>

			<b-row class="mt-2" align-v="center">

				<b-col cols="3">Источник информации:</b-col>
				<b-col class="floor-height_show_field">

					<b-form-input v-model="raw_data.source" v-on:change="(value) => save('source', value)"
						:readonly="$root.not_editable || ! check_roles([ 'model' ])"
					/>

				</b-col>

			</b-row>

		</b-container>

	</div>

</template>

<script>

import api from "../../../../api"
import reference_values from "../../../widgets/reference"

export default
{
	components :
	{
		reference_values,
	},

	data()
	{
		return {

			service : "cadastral_floor_height",

			id : null,
			data : {},
			raw_data : {},

			functional_sub_group_state : null,

			states :
			{
				floor_h : null,
				underground_h : null,
				wall_k : null,
				overlap_h : null
			}
		}
	},

	created() 
	{
		this.id = this.$route.params.id

		return this.refresh()
	},

	methods :
	{
		refresh()
		{
			return api.call(this, this.service, "get", { id : this.id },
				response =>
				{ 
					this.data = response.data

					delete this.data["id"]

					this.raw_data = api.deep_clone(this.data)
				})
		},

		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		check_number(value)
		{
			return api.check_number({ value, gt : 0 })
		},

		formatter(field, value)
		{
			if (value === "" || Number(value) === 0 || this.check_number(value))
			{
				return value
			}
			else
			{
				return this.raw_data[field]
			}
		},

		validate(field, value)
		{
			this.check_number(value) ? this.states[field] = null : this.states[field] = false
		},

		save(field, value)
		{
			if (!this.$root.not_editable && this.check_roles([ 'model' ]))
			{
				if (Object.keys(this.states).includes(field))
				{
					if (this.check_number(value))
					{
						this.data[field] = Number(value)

						api.call(this, this.service, "edit", { id : this.id, fields : this.data },
							() => {
								api.show_notification(this, "Изменения сохранены")
								this.refresh()
							},
							( self, err ) =>
							{
								if(err.error == "ObjectExists")
									this.states.functional_sub_group.state = false
								else if(err.error == "WallKIsZero")
									this.states.wall_k.state = false
							})
					}
					else
					{
						this.raw_data[field] = this.data[field]
						this.validate(field, this.raw_data[field])
					}
				}
				else
				{
					this.data[field] = value
					api.call(this, this.service, "edit", { id : this.id, fields : this.data },
						() => {
							api.show_notification(this, "Изменения сохранены")
							this.refresh()
						},
						( self, err ) =>
						{
							if(err.error == "ObjectExists")
								this.states.functional_sub_group.state = false
							else if(err.error == "WallKIsZero")
								this.states.wall_k.state = false
						})
				}
			}
		},

		go_back()
		{
			api.back.go(this)
		},
	}
}

</script>

<style>
.floor-height_show_field
{
    position: relative;
}

.floor-height_show_field .invalid-tooltip
{
    display: none;
    top: 1.625rem;
    left: unset;
    right: .5rem;
    background-color: var(--bft-neutral-900-tooltip);
    max-width: max-content;
}

.floor-height_show_field .form-control.is-invalid:hover + .invalid-tooltip
{
    display: block;
}
</style>
